import { memo } from 'react'

import s from './ControlsError.module.scss'

import { ExclamationIcon } from 'assets/icons/ExclamationIcon'

export const ControlsError = memo(({ error, className = '' }: { error: string; className?: string }) => {
  return (
    <div className={`${s.errorText} ${className}`}>
      <ExclamationIcon className={s.errorIcon} />
      {error}
    </div>
  )
})
